<template>
	<label
		class="flex items-center bg-slate-50 border border-blue-300 rounded-md hover:shadow-md focus-within:shadow-sm transition w-full overflow-x-hidden"
		:class="{
			'justify-start': position !== 'center',
			'justify-center': position === 'center',
		}">
		<div
			class="flex items-center relative"
			:class="{
				'w-full': position !== 'center',
				'w-auto': position === 'center',
			}">
			<p v-if="$slots.icon" class="pb-0.5 pt-4 px-2 text-slate-700" :title="placeholder">
				<slot name="icon"></slot>
			</p>
			<input
				:type="type"
				class="pb-0.5 pt-4 px-2 text-slate-700 bg-slate-50 border-none focus:ring-0 focus:outline-none w-full flex-grow peer sm:text-md text-sm"
				:value="modelValue"
				@input="$emit('update:modelValue', $event.target.value)"
				:min="min"
				:max="max"
				:disabled="disabled" />
			<p
				class="absolute text-blue-400 text-base ml-2 origin-left transform start-[0] peer-focus:-translate-y-1/2 peer-focus:scale-75 transition sm:text-md text-sm"
				:class="[modelValue ? '-translate-y-1/2 scale-75' : '', $slots.icon ? 'pb-0.5 pt-4 pl-6' : '']">
				{{ placeholder }}
			</p>
		</div>
	</label>
</template>

<script setup>
	defineProps({
		modelValue: {
			type: [String, Number],
			default: null,
		},
		placeholder: {
			type: String,
			default: '',
		},
		position: {
			type: String,
			default: 'left',
		},
		type: {
			type: String,
			default: 'text',
		},
		min: {
			type: [String, Number],
			default: '',
		},
		max: {
			type: [String, Number],
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	});

	defineEmits(['update:modelValue']);
</script>
